import { Button, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { fsColors } from '../../../shared/constants'
import { useAppSelector } from '../../../store/hooks'
import { getIcon } from '../Icons'

interface FSButtonProps {
  icon: string
  header: string
  content: string
  size: 'sm' | 'lg'
  disabled: boolean
  onClick: () => void
}

const FSCardButton = ({ icon, header, content, size, disabled, onClick }: FSButtonProps) => {
  const { t } = useTranslation()
  const { currentTheme } = useAppSelector((state) => state.currentUser)

  switch (size) {
    case 'lg':
      return (
        <Button
          variant="outlined"
          onClick={onClick}
          sx={{
            textTransform: 'none',
            marginRight: 2,
            marginBottom: 1,
            padding: 1.5,
            color: currentTheme === 'light' ? fsColors.fsGray.colors[0] : '#fff',
            backgroundColor:
              currentTheme === 'light' ? fsColors.fsGray.colors[5] : fsColors.fsGray.colors[0],
            boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
            borderColor: 'transparent',
            borderRadius: '6px',
            transition: 'all 0.25s ease-in-out',
            '&:hover': {
              backgroundColor:
                currentTheme === 'light' ? fsColors.fsGray.colors[3] : fsColors.fsGray.colors[0],
              borderColor:
                currentTheme === 'light' ? fsColors.fsGray.colors[3] : fsColors.fsGray.colors[1],
              boxShadow: 'none',
              transform: 'scale(1.02)',
            },
          }}
          style={{}}
        >
          <Stack mr={2} ml={2} sx={{ color: fsColors.fsDarkBlue.colors[1] }}>
            {getIcon(icon, { height: 60, width: 60 })}
          </Stack>
          <Stack sx={{ alignItems: 'flex-start' }}>
            <Typography variant="h3" m={1}>
              {t(header as any)}
            </Typography>
            <Typography variant="body1" mb={2.5} ml={1} align="left">
              {t(content as any)}
            </Typography>
          </Stack>
        </Button>
      )
    default:
      return (
        <Button
          variant="outlined"
          onClick={onClick}
          sx={{
            textTransform: 'none',
            marginRight: 2,
            marginBottom: 1,
            padding: 1,
            color: disabled ? fsColors.fsGray.colors[0] : fsColors.fsGray.colors[1],
            backgroundColor:
              disabled && currentTheme === 'dark'
                ? fsColors.fsGray.colors[2]
                : fsColors.fsGray.colors[5],
            boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
            borderColor: 'transparent',
            borderRadius: 1,
            transition: 'all 0.25s ease-in-out',
            pointerEvents: disabled ? 'none' : 'all',
            '&:hover': {
              backgroundColor:
                currentTheme === 'dark' ? fsColors.fsGray.colors[0] : fsColors.fsGray.colors[3],
              borderColor: disabled ? fsColors.fsGray.colors[3] : fsColors.fsGray.colors[3],
              boxShadow: 'none',
              transform: disabled ? 'none' : 'scale(1.02)',
            },
          }}
        >
          <Stack
            ml={2}
            sx={{ color: disabled ? fsColors.fsDarkBlue.colors[1] : fsColors.fsGray.colors[1] }}
          >
            {getIcon(icon)}
          </Stack>
          <Stack sx={{ alignItems: 'flex-start' }}>
            <Typography variant="h6" m={1}>
              {t(header as any)}
            </Typography>
          </Stack>
        </Button>
      )
  }
}

export default FSCardButton
